export const getYoutubeThumbnail = (videoId:string) => {
    const thumbnail = `http://img.youtube.com/vi/${videoId}/0.jpg`    
    return thumbnail
}